// extracted by mini-css-extract-plugin
export default {"CoursesEmpty":"CoursesEmpty_CoursesEmpty__5drSg","CoursesEmpty__image":"CoursesEmpty_CoursesEmpty__image__RHCYu"};